import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpService } from './http.service';
import { AppService } from './app.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class UnitTestsService {
    constructor(private httpService: HttpService, private appService: AppService) {}

    public getUnitTests() {
        const url = `${environment.http.quotation}quotations/quote-assist-pro/unit-tests`;
        return this.httpService.get(url, new HttpParams().set('salesOrg', this.appService.getSalesOrg()));
    }

    public startSingleUnitTest(id: string) {
        const url = `${environment.http.quotation}quotations/quote-assist-pro/unit-tests/${id}/execute`;
        return this.httpService.post(url, {
            salesOrg: this.appService.getSalesOrg(),
            salesAreaName: this.appService.getSalesAreaName(),
            language: this.appService.getLanguageAsLocale(),
        });
    }

    public getPimProducts(materials: string[]) {
        const url = `${environment.http.pim}products/de/de`;
        return this.httpService.post(url, { products: materials });
    }
}
